import api from "@/lib/api";

export const CHUNK_SIZE = 3 * 1024 * 1024; // 3 MB per request — safely under the proxy body limit

/** Uploads one claim video in chunks. onProgress(0..100). Returns {id, name, size}. */
export async function uploadClaimVideo(orderId, file, onProgress, signal) {
  const init = (await api.post(`/orders/${orderId}/claim-media/init`, {
    name: file.name, content_type: file.type || "video/mp4", size: file.size, chunk_size: CHUNK_SIZE,
  })).data;
  const total = init.total_chunks;
  for (let i = 0; i < total; i++) {
    if (signal?.aborted) throw new DOMException("Upload cancelled", "AbortError");
    const blob = file.slice(i * CHUNK_SIZE, Math.min(file.size, (i + 1) * CHUNK_SIZE));
    let attempt = 0;
    for (;;) {
      try {
        await api.put(`/claim-media/${init.id}/chunks/${i}`, blob, { headers: { "Content-Type": "application/octet-stream" }, timeout: 120000, signal });
        break;
      } catch (e) {
        if (signal?.aborted || ++attempt >= 3) throw e;
        await new Promise((r) => setTimeout(r, 800 * attempt));
      }
    }
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  const done = (await api.post(`/claim-media/${init.id}/complete`)).data;
  return { id: init.id, name: done.name, size: done.size };
}

export const claimVideoUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/claim-media/${id}`;

export const fmtBytes = (n) => (n >= 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
